import React, { Fragment, useState, useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next/hooks';
import axios from 'axios';
import { useAudioRecorder } from 'react-audio-voice-recorder';

import Backdrop from '../../Backdrop/Backdrop';
import Button from '../../Button/Button';
import SmallModal from '../../Modal/SmallModal';

// import ImageEditorLink from '../../../pages/NotPageFound/ImageEditorLink';
// import InputEmoji from '../../Form/Input/InputEmoji';
// import Input from '../../Form/Input/Input';
// import Loader from '../../Loader/Loader';
// import GroupUpladPreview from './GroupUploadPreview';
// import GroupUploadFromKuraInfo from './GroupUploadFromKuraInfo';
// import { talkFileUpload } from '../../../util/talk-upload';


import { useStore } from '../../../hook-store/store';

import { SOCKET_GROUP_URL } from '../../../App';

import { marks } from '../../../images/marks';
// import classes from './GroupUpload.module.css';
import classes from './GroupTalkAudioRecord.module.css';

const GroupTalkAudioRecord = props => {
  // console.log('VideoTextTalkUpload.js-props', props);
  const { 
    showAudioRecordModalHandler,

    // noconnectDestUserId,
    // noconnectTextPostHandler,
    joinGroupId,
    groupTextPostHandler,
    isTextPosting,
  } = props;

  const [t] = useTranslation('translation');

  const recorderControls = useAudioRecorder();

  const [store, dispatch] = useStore();
  const userData = store.userData;

  const [textInput, setTextInput] = useState('');
  const [recordedBlob, setRecordedBlob] = useState();
  const [recordedEl, setRecordedEl] = useState();
  const [errorMessage, setErrorMessage] = useState('')
  const [sizeError, setSizeError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!recorderControls.recordingBlob) {
      return
    } else {
      // console.log(recorderControls.recordingBlob);
      setRecordedBlob(recorderControls.recordingBlob);
    };

    // recordingBlob will be present at this point after 'stopRecording' has been called
  }, [recorderControls.recordingBlob]);

  useEffect(() => {
    // console.log(recorderControls.recordingTime);
    if (recorderControls.recordingTime > 60) {
      recorderControls.stopRecording();
    }
  },[recorderControls.recordingTime]);


  const textInputHandler = (event) => {
    if (event.target.value) {
      setTextInput(event.target.value.trim());
    }
  }

  const recordCloseHandler = () => {
    if (!recordedBlob) {
      showAudioRecordModalHandler(false); 
    } else {
      let userConfirmation = window.confirm(
        `${t('audioRecordtext83', 'Finish audio recording? Recorded audio is deleted.')}`
      );

      if (userConfirmation) {
        // User clicked OK
        showAudioRecordModalHandler(false); 
      } else {
        // User clicked Cancel
      }
    }
  };

  const recordAudioUploadHandler = async (url, token, recordedBlob) => {
    try {
      setIsLoading(true);
      setErrorMessage('');
      // const fileList = [];
      
      // for (const file of files) {
      //   fileList.push(file);
      // }

      const formData = new FormData();
      
      // console.log('files[0]', files[0]); 
      const file = new File(
        [recordedBlob], 
        `group-record-${joinGroupId}-${Date.now()}.webm`, 
        { type: 'audio/webm' },
      );

      const files = [file];

      for (const file of files) {
        formData.append('files', file);
      }

      if (userData) {
        formData.append('userId', userData.userId);
      }

      formData.append('joinGroupId', joinGroupId);

      // formData.append('file', files[0]);
  
      const result = await axios.request({
        method: 'POST',
        url: url + `/file-upload`,
        data: formData,
        headers: {
          Authorization: 'Bearer ' + token,
        },
        onUploadProgress: (p) => {
          console.log('onUploadProgress', (p.loaded/p.total*100).toFixed(0), p); 
          // this.setState({
          //     uploadProgress: p.loaded / p.total * 100
          // });
        }
      });
  
      console.log(result);

      if (result.data) {
        const fileUrls = result.data.data.fileUrls;
        const fileSizes = result.data.data.fileSizes;

        const forText = textInput.trim() ? textInput : 'recorded audio';
        
        // noconnectTextPostHandler(
        //   forText, 
        //   noconnectDestUserId, 
        //   fileUrls,
        //   fileSizes,
        // );

        groupTextPostHandler(
          forText, 
          joinGroupId,
          fileUrls,
          fileSizes,
        );
        // console.log(fileUrls);
      }
      
      setIsLoading(false);
      showAudioRecordModalHandler(false);

      return result;

    } catch(err) {
      console.log(err);
      setIsLoading(false);
      setErrorMessage('File Upload Failed');
      throw err;
    }
  };


  useMemo(() => {
    if (recordedBlob) {
      setRecordedEl(
        <div>        
          <audio className={classes.audioRecordRecordedAudio}
            src={URL.createObjectURL(recordedBlob)}
            controls
          />
        </div>
      );
    }
  }, [recordedBlob]);





  let groupTalkAudioRecordBody;

  groupTalkAudioRecordBody = (
    <div>
      <Backdrop onClick={() => { 
        recordCloseHandler();
          // showAudioRecordModalHandler(false); 
        }}
      />
      <SmallModal style={classes.audioRecordModal}
      // style={classes.uploadModal}
      >
        <div className={classes.audioRecordRow}>
          <div className={classes.audioRecordClose}>
            <span className={classes.audioRecordCloseButton}
              onClick={() => {
                recordCloseHandler();
                // showAudioRecordModalHandler(false); 
              }}
            >
              X
            </span>
          </div>
        </div>
        <div className={classes.audioRecordRow}>
          {!recorderControls.isRecording && (
            <Button mode="" type="submit" 
              onClick={recorderControls.startRecording}
            >
              {t('groupTalk.text84', 'Audio record')} {marks.microphoneMark}
            </Button>
          )}

          {recorderControls.isRecording && recorderControls.isPaused && (
            <Button mode="" type="submit"
            onClick={recorderControls.togglePauseResume}>
              {t('groupTalk.text85', 'Resume')} {marks.microphoneMark}
            </Button>
          )}
          {recorderControls.isRecording && !recorderControls.isPaused && (
            <Button mode="" type="submit" 
            onClick={recorderControls.togglePauseResume}>
              {t('groupTalk.text86', 'Pause')} {marks.pauseMark}
            </Button>
          )}
          {recorderControls.isRecording && (
            <Button mode="" type="submit" 
            onClick={recorderControls.stopRecording}>
              {t('groupTalk.text87', 'Finish')} {marks.stopMark}
            </Button>
          )}
          
          {/* <div>{JSON.stringify(recorderControls)}</div> */}
        </div>

        {recorderControls.isRecording && (
          <div className={classes.audioRecordRow}>
            {!recorderControls.isPaused && (
              <div>
                {t('groupTalk.text88', 'Audio recording')}... {recorderControls.recordingTime} {t('groupTalk.text90', 'seconds')} ({t('groupTalk.text91', 'max 60 seconds')})
              </div>
            )}
              {recorderControls.isPaused && (
              <div>
                {t('groupTalk.text89', 'Paused')}. {recorderControls.recordingTime} {t('groupTalk.text90', 'seconds')} ({t('groupTalk.text91', 'max 60 seconds')})
              </div>
            )}
          </div>
        )}

        {!recorderControls.isRecording && recordedBlob && (
          <div>
            <div className={classes.audioRecordRow}>
            {recordedEl}
            </div>
            <div className={classes.audioRecordRow}>
              <div>
                <label>
                  {t('groupTalk.text92', 'Text for audio')}
                </label>
              </div>
              <div>
                <textarea className={classes.audioRecordInput}
                  type='text'
                  placeholder=''
                  onChange={(event) => {
                    textInputHandler(event);
                  }}
                />
              </div>
            </div>
            <div className={classes.audioRecordRow}>
              <div className={classes.audioRecordActionButton}>
                <Button mode="raised" type="submit"
                  disabled={isTextPosting || isLoading || sizeError}
                  loading={isTextPosting || isLoading}
                  onClick={() => {
                      recordAudioUploadHandler(
                        // BASE_URL,
                        SOCKET_GROUP_URL,
                        localStorage.getItem('token'),
                        recordedBlob,
                      );
                  }}
                >
                  {t('talkUpload13', 'Upload')}
                </Button>
              </div>
            </div>
          </div>
        )}
      </SmallModal>

    </div>
  );


  return (
    <Fragment>
      <div>{groupTalkAudioRecordBody}</div>
    </Fragment>

  );
}

export default GroupTalkAudioRecord;